import LocationIcon from "./locationIcon";
import WebsiteIcon from './websiteIcon';
import EmailContact from './emailContact';
import FbIcon from './fbIcon';
import InstagramIcon from './instagram';
import TwitterIcon from './twitter';
import YoutubeIcon from './youtube';
import WifiIcon from './wifi';
import EmailIconFooter from './emailIcon';
import PhoneTalkFooter from './phoneTalkFooter';
export const iconSvg = {
  location: <LocationIcon />,
  websiteIcon: <WebsiteIcon />,
  emailContact: <EmailContact />,
  fbIcon: <FbIcon />,
  instagramIcon: <InstagramIcon />,
  twitterIcon: <TwitterIcon />,
  youtubeIcon: <YoutubeIcon />,
  wifiIcon: <WifiIcon />,
  emailFooter:<EmailIconFooter/>,
  phoneTalkFooter:<PhoneTalkFooter/>
};
